import React, {FC, ReactNode} from 'react';

import s from './submenu-title.module.less';

interface ISubmenuTitleProps {
    children: ReactNode;
    disabled?: boolean;
};

export const SubmenuTitle: FC<ISubmenuTitleProps> = ({children, disabled = false}: ISubmenuTitleProps) => (
  <span className={s[disabled ? 'title_disabled' : 'title']}>
      {children}
  </span>
);
